<template>
  <v-container>
    <v-row><v-col><watched-films :by="id" /></v-col></v-row>
    <v-row><v-col><reviewed-films :by="id" /></v-col></v-row>
  </v-container>
</template>

<script>
import WatchedFilms from "@/components/films/WatchedFilms"
import ReviewedFilms from "@/components/films/ReviewedFilms"

export default {
  name: "UserHome",
  components: {
    WatchedFilms,
    ReviewedFilms,
  },
  props: {
    id: {
      type: Number | String,
      required: true,
    },
  },
}
</script>
